import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import SearchRender from "../SearchRender/index";
import { searchPost } from "../../../../../redux/modules/postSlice";

function PaginationSearch({
  keyWord,
  correctKeyWord,
  currentPage,
  currentPageFunc,
  postsList, // 검색어별 게시글 목록
  totalLength, // 검색어별 게시글 총 개수
  setPostsListFunc,
}) {
  const dispatch = useDispatch();
  const targetRef = useRef(null);
  const totalPage = Math.ceil(totalLength / 5);

  useEffect(() => {
    const payload = {
      keyword: keyWord.trim().replace(/ +(?= )/g, ""),
      page: currentPage + 1,
    };
    if (totalPage > currentPage) {
      dispatch(searchPost(payload))
        .unwrap()
        .then((res) => {
          setPostsListFunc(res.data);
        });
    }
  }, [dispatch, totalPage, currentPage]);

  // 무한스크롤
  const callback = ([entries]) => {
    if (entries.isIntersecting) {
      currentPageFunc();
    }
  };

  useEffect(() => {
    if (!targetRef.current) return;
    const observer = new IntersectionObserver(callback, {
      threshold: 1,
    });
    observer.observe(targetRef.current);
  }, [targetRef, totalPage]);

  return (
    <>
      {postsList.length > 0 &&
        postsList.map((post) => (
          <SearchRender
            key={post.boardId}
            post={post}
            keyWord={keyWord}
            correctKeyWord={correctKeyWord}
          />
        ))}
      {totalPage > currentPage && <div ref={targetRef}>Loading...</div>}
    </>
  );
}

export default PaginationSearch;
